import { render } from "./DataCollector.vue?vue&type=template&id=c7eb3de2"
import script from "./DataCollector.vue?vue&type=script&lang=js"
export * from "./DataCollector.vue?vue&type=script&lang=js"

import "./DataCollector.vue?vue&type=style&index=0&id=c7eb3de2&lang=css"

import exportComponent from "/root/.jenkins/workspace/hidoc/hidoc-web/03_SRC/hidoc-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__